<app-header [isMobile]="isMobile"></app-header>
<div class="topBg"></div>

<div class="wrapper">
    <div class="backButton">
        <a routerLink="/">
            <img src="assets/img/back-button2.png" class="back" alt="">
            <img src="assets/img/back-button2-rollover.png" class="backOver" alt="">
        </a>
    </div>

    <div class="content">
        <div class="item" *ngFor="let item of pageData.data">
            <div class="left">
                <a [routerLink]="item.link" class="imgLink">
                    <img [src]="item.image" alt="">
                    <div class="border" [ngStyle]="{border: '4px solid #000'}" ></div>
                </a>


                <a class="button channelPreview" (click)="onOpenSizzleOverlay(item.buttons.button.url)" *ngIf="item.buttons && item.sizzleVideoLabel != '' ">
                    <div class="bg" [ngStyle]="{backgroundColor: item.buttons.button.colorBG}"></div>
                    <div class="label" [ngStyle]="{color: item.buttons.button.color}">
                        <div class="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                version="1.1" width="256" height="256" viewBox="0 0 256 256"
                                xml:space="preserve">

                                <defs>
                                </defs>
                                <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;"
                                    transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                                    <path [ngStyle]="{fill: item.buttons.button.color}"
                                        d="M 45 90 C 20.187 90 0 69.813 0 45 C 0 20.187 20.187 0 45 0 c 24.813 0 45 20.187 45 45 C 90 69.813 69.813 90 45 90 z M 45 10 c -19.299 0 -35 15.701 -35 35 s 15.701 35 35 35 s 35 -15.701 35 -35 S 64.299 10 45 10 z"
                                        style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10;  fill-rule: nonzero; opacity: 1;"
                                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                    <path [ngStyle]="{fill: item.buttons.button.color}"
                                        d="M 61.806 47.026 c 1.559 -0.9 1.559 -3.151 0 -4.051 l -12.91 -7.453 l -12.91 -7.453 c -1.559 -0.9 -3.509 0.225 -3.509 2.026 V 45 v 14.907 c 0 1.801 1.949 2.926 3.509 2.026 l 12.91 -7.453 L 61.806 47.026 z"
                                        style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10;  fill-rule: nonzero; opacity: 1;"
                                        transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                </g>
                            </svg>
                        </div>
                        <span [innerHTML]="item.sizzleVideoLabel"></span>
                    </div>
                </a>

            

                <a *ngIf="item.buttons && !item.buttons.button.external" [routerLink]="item.buttons.button.url" class="button shceduleButton">
                    <div class="bg" [ngStyle]="{backgroundColor: item.buttons.button.colorBG}"></div>
                    <div class="label" [innerHTML]="item.buttons.button.label"
                        [ngStyle]="{color: item.buttons.button.color}"></div>
                </a>

                <a *ngIf="item.site" [href]="item.site" target="_blank" class="button shceduleButton">
                    <div class="bg" [ngStyle]="{backgroundColor: item.buttons.button.colorBG}"></div>
                    <div class="label" [innerHTML]="'Visit Site'"
                        [ngStyle]="{color: item.buttons.button.color}"></div>
                </a>
            </div>
            <div class="right">
                <a [routerLink]="item.link" class="titleLink">
                    <div class="title" [innerHTML]="item.title | safeHtml"></div>
                </a>

                <div class="description" [innerHTML]="item.description | safeHtml"></div>

                <!-- <div class="descriptionButtons" *ngIf="item.buttons">

                    <span c;ass="descText" [innerHTML]="item.description | safeHtml"></span>
                </div> -->

                <div class="available" *ngIf="item.whereToWatch.length > 0"> Streaming on the following platforms: </div>
                
                   



                <div class="listWrapper">
                    <a [href]="linkItem.link" target="_blank" *ngFor="let linkItem of item.whereToWatch"
                        [ngClass]="{disabled: linkItem.link == ''}">
                        <img [src]="linkItem.logo" alt="">
                        
                    </a> 
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer [isInverted]="true"></app-footer>

<div class="sizzleBg" [ngClass]="{open: pageData.isOverlayOpen}"></div>
<app-sizzle-overlay></app-sizzle-overlay>